import Figure from "~/components/figure"
import CurvesRadial from "~/components/curvesRadial"

export default class FirstRadial extends Component {
  render() {
    const { data } = this.props
    const activeLayer = data.filter(({ layer }) => layer === "mixed3b")[0]

    const size = 400

    return (
      <Surface gridColumn="screen" alignItems="center" margin={20}>
        <Surface
          flexFlow="row"
          width={window.innerWidth - 200}
          justifyContent="center"
          alignItems="center"
        >
          <Surface width={450} marginRight={100}>
            <Text fontSize={18} lineHeight={1.5} marginY={20}>
              Viewing synthetic responses radially allows us to quickly
              understand curve detectors in a layer. Hover to isolate a
              particular neuron
            </Text>
            <Text fontSize={18} lineHeight={1.5} marginY={20}>
              Notice that many curve neurons overlap, and there is no point in
              the circle where no curve detector fires.
            </Text>
          </Surface>
          <Surface>
            <Text fontSize={30} fontWeight={700}>
              3b
            </Text>
            <CurvesRadial
              {...activeLayer}
              size={size}
              fillOpacity={0.4}
              orientationType={"max"}
            />
          </Surface>
        </Surface>
      </Surface>
    )
  }
}
